import { TFunction } from 'i18next'

export const BDC_convertLevelToHumanFriendly = (level: string, t: TFunction<[string, string], undefined>) => {
  if (!level || typeof level !== 'string') {
    return '---'
  }

  const upperLevel = level.toUpperCase()
  const translatedLevel = t(`common:negativeMediaLevel.${upperLevel}`)

  // If translation exists, return it with the original letter in parentheses
  if (translatedLevel && translatedLevel !== `common:negativeMediaLevel.${upperLevel}`) {
    return `${translatedLevel} (${upperLevel})`
  }

  // If no translation found, return the original level
  return level
}
